import React from 'react';

import { ApLoaderDefault, ApLoaderText } from '@alixpartners/ui-components';
import { SpendTypeEnum, ITaxonomyItem, IRuleItem } from '../Classification';
import { getTaxonomy, getClassificationRules, saveRules } from 'utils/api';
import { LoaderWrapper } from './ClassificationRules.styles';
import thirdPartyConfig, {
  GROUP_COLUMNS as THIRD_PARTY_GROUPPINGS,
} from './thirdPartyConfig';
import personnelConfig, {
  GROUP_COLUMNS as PERSONNEL_GROUPPINGS,
} from './personnelConfig';
import ClassificationRulesTable from './ClassificationRulesTable';

interface IProps {
  spendType: SpendTypeEnum;
}

interface IState {
  rulesData: { [key in SpendTypeEnum]?: any };
  taxonomyData: { [key in SpendTypeEnum]?: ITaxonomyItem[] };
}

const getGridConfig = (spendType: SpendTypeEnum) => {
  const configByType = {
    [SpendTypeEnum.THIRD_PARTY]: thirdPartyConfig,
    [SpendTypeEnum.PERSONNEL]: personnelConfig,
  };

  return configByType[spendType];
};

export class ClassificationRulesContainer extends React.Component<
  IProps,
  IState
> {
  state = {
    rulesData: {} as IState['rulesData'],
    taxonomyData: {} as IState['taxonomyData'],
  };

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps: IProps) {
    const { spendType } = this.props;

    if (prevProps.spendType !== spendType) {
      this.fetchData();
    }
  }

  fetchData = () => {
    const { spendType } = this.props;
    const { taxonomyData } = this.state;

    return Promise.all([getClassificationRules(), getTaxonomy(spendType)]).then(
      ([rulesData, taxonomy]) => {
        this.setState({
          rulesData: {
            [SpendTypeEnum.PERSONNEL]: rulesData.personnelRules,
            [SpendTypeEnum.THIRD_PARTY]: rulesData.thirdPartyRules,
          },
          taxonomyData: { ...taxonomyData, [spendType]: taxonomy },
        });
      }
    );
  };

  getColumnGroups = () => {
    const { spendType } = this.props;

    const grouppingsByType = {
      [SpendTypeEnum.THIRD_PARTY]: THIRD_PARTY_GROUPPINGS,
      [SpendTypeEnum.PERSONNEL]: PERSONNEL_GROUPPINGS,
    };

    return grouppingsByType[spendType];
  };

  updateRule = (data: IRuleItem) => {
    const { spendType } = this.props;

    return saveRules(spendType, [data]);
  };

  render() {
    const { rulesData, taxonomyData } = this.state;
    const { spendType } = this.props;

    if (!rulesData[spendType] || !taxonomyData[spendType]) {
      return (
        <LoaderWrapper>
          <ApLoaderDefault loaderText={() => <ApLoaderText />} />
        </LoaderWrapper>
      );
    }

    return (
      <React.Fragment>
        {!rulesData[spendType] || !taxonomyData[spendType] ? (
          <LoaderWrapper>
            <ApLoaderDefault loaderText={() => <ApLoaderText />} />
          </LoaderWrapper>
        ) : (
          <ClassificationRulesTable
            spendType={spendType}
            taxonomyOptions={taxonomyData[spendType]!}
            updateRule={this.updateRule}
            gridConfig={{
              ...getGridConfig(spendType),
              rowData: rulesData[spendType],
            }}
            columnGroups={this.getColumnGroups()}
          />
        )}
      </React.Fragment>
    );
  }
}
